export default __webpack_public_path__ + "static/media/chandosBook@2x.2b78d42d.jpg";